<template>
  <div class="error-page-container">
    <div class="added-logo">
      <slot name="addedLogo"></slot>
    </div>
    <div class="heading font-secondary">
      <slot name="header"></slot>
    </div>
    <div class="message">
      <slot name="message"></slot>
    </div>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
  import FooterBar from './FooterBar'
  export default {
    name: 'ErrorPage',
    components: {
      FooterBar
    },
  }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .error-page-container{
    width: 60%;
    max-width: 1024px;
  }

  .added-logo {
    padding-top: 8%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .heading {
    color: $red-2;
    font-weight: bolder;
    font-size: large;
    padding-top: 8%;
  }

  .message {
    padding-top: 8%;
    padding-bottom: 15%;
  }

</style>
